<template>
    <CustomDialog
        title="溫馨提醒"
        :show-close-button="false"
        :show-header-divider="true"
        @close="onClose"
    >
        <div class="mt-[20px] flex flex-col justify-center bg-white rounded-b-3xl gap-[30px]">
            <div class="mx-auto">
                <img
                    src="@/assets/images/dialog/remindBell.svg"
                    loading="lazy"
                    alt="remindBell"
                >
            </div>
            <div class="text-center">
                <div>您好，因網頁閒置已逾{{ promptTimeout / 60 }}分鐘未進行任何操作，基於資訊安全的考量，</div>
                <div>{{ timeout }} 秒後自動登出</div>
            </div>
            <div class="flex align-center gap-[10px] mx-auto">
                <FormButton
                    text="立即登出"
                    outline
                    is-popup
                    @click="onClickLogout"
                />
                <FormButton
                    text="保持登入"
                    is-popup
                    @click="onClose"
                />
            </div>
        </div>
    </CustomDialog>
</template>

<script>
import CustomDialog from '@/components/Dialog';
import FormButton from '@/components/forms/Button.vue';

/**
 *  彈跳視窗-超時登出
 */
export default {
    name: 'IdleComponent',
    components: {FormButton, CustomDialog},
    computed: {
        /**
         * 用於回傳 .env 設定的登入時間
         * 
         * @returns .env 設定的登入時間
         */
        promptTimeout() {
            return process.env.VUE_APP_IDLE_PROMPT_TIMEOUT;
        },
        /**
         * 用於提醒登入後剩幾秒，會自動登出
         * 
         * @returns Vuex store 中儲存的 idle 時間
         */
        // @returns Vuex store 中儲存的 idle 時間
        timeout() {
            return this.$store.state.idle.timeout;
        }
    },
    methods: {
        /**
         * 繼續保持登錄狀態
         * 
         * @public
         */
        onClose() {
            this.$idle.start();
        },
        /**
         * 登出
         * 
         * @public
         */
        onClickLogout() {
            this.$auth.logout();
            this.$idle.stop();
        }
    }
};
</script>